import { render, staticRenderFns } from "./SubscriptionVariantYearComponent.vue?vue&type=template&id=4fa524be"
import script from "./SubscriptionVariantYearComponent.vue?vue&type=script&lang=js"
export * from "./SubscriptionVariantYearComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports